import React, { useEffect, useState, useRef } from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import ReactJson from 'react-json-view'
import GTCDisplayPlan from "../components/GTCDisplayPlan";
import GTCLinearProgress from "../components/GTCLinearProgress";
import GTCChart from "../components/GTCChart";
import GTCReportTable from "../components/GTCReportTable";
import GTCUsageGuide from "../components/GTCUsageGuide";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-monokai"
import "ace-builds/src-noconflict/ext-language_tools";
import { useParams, useNavigate } from "react-router-dom"
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import moment  from "moment";
import '../css/gtc-channel.css'
import '../css/shared-components.css';
import { FaExclamationTriangle } from 'react-icons/fa';


const placeholder = `*
domain.com
0.0.0.0
2001:0000:130F:0000:0000:09C0:876A:130B
0.0.0.0/24
0.0.0.0 - 0.0.0.255
PH
desktop
Googlebot`;


const jsRgeoFetch = (url: string, key: string, lat: string, lng: string) => {
return `
// GET Request
(async () => {
    const res = await fetch("${url}?key=${key}&latlng=${lat},${lng}");
    const data = await res.json();
    console.log(data)
})();

// GET Request
(async () => {
    const res = await fetch("${url}?key=${key}&lat=${lat}&lng=${lng}");
    const data = await res.json();
    console.log(data)
})();

// GET Request with XML output
(async () => {
    const res = await fetch("${url}?key=${key}&lat=${lat}&lng=${lng}&output=xml");
    const data = await res.text();
    console.log(data)
})();

// POST Request
(async () => {
    const res = await fetch("${url}", {
        method: "POST",
        data: JSON.stringify({
            key: "${key}",
            lat: ${lat},
            lng: ${lng}
        })
    });
    const data = await res.json();
    console.log(data)
})();
`;
}

const jsGeoFetch = (url: string, key: string, ip: string) => {
return `
// GET Request
(async () => {
    const res = await fetch("${url}?key=${key}&ip=${ip}");
    const data = await res.json();
    console.log(data)
})();

// GET Request with XML output
(async () => {
    const res = await fetch("${url}?key=${key}&ip=${ip}&output=xml");
    const data = await res.text();
    console.log(data)
})();

// POST Request
(async () => {
    const res = await fetch("${url}", {
        method: "POST",
        data: JSON.stringify({
            key: "${key}",
            ip: ${ip},
        })
    });
    const data = await res.json();
    console.log(data)
})();
`;
}


const rgeoJson = `{
    "origin": {
        "ip": "143.44.165.209",
        "type": "ipv4",
        "platform": "macOS",
        "referer": null,
        "device": "desktop",
        "address": {
            "city": "Cebu City",
            "region": "07",
            "regionName": "Central Visayas",
            "country": "PH",
            "countryName": "Philippines",
            "postalCode": "6000",
            "timezone": "Asia/Manila"
        }
    },
    "target": {
        "lat": 10.3451098,
        "lng": 123.9223035,
        "address": [
            {
                "priority": 1,
                "address": "8WWC+2WJ, P.Remedio St, Mandaue City, Cebu, Philippines",
                "street": "P.Remedio Street",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 2,
                "address": "18b P.Remedio St, Mandaue City, 6014 Cebu, Philippines",
                "street_number": "18b",
                "street": "P.Remedio Street",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines",
                "postal_code": "6014"
            },
            {
                "priority": 3,
                "address": "6014 P.Remedio St, Mandaue City, Cebu, Philippines",
                "street_number": "6014",
                "street": "P.Remedio Street",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 4,
                "address": "18 P.Remedio St, Mandaue City, Cebu, Philippines",
                "street_number": "18",
                "street": "P.Remedio Street",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 5,
                "address": "18 P.Remedio St, Mandaue City, Cebu, Philippines",
                "street_number": "18",
                "street": "P.Remedio Street",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 6,
                "address": "8WWC+2W Mandaue City, Cebu, Philippines",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 7,
                "address": "Banilad, Mandaue City, Cebu, Philippines",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 8,
                "address": "Mandaue City, Cebu, Philippines",
                "city": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 9,
                "address": "Mandaue City, Cebu, Philippines",
                "district": "Mandaue City",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 10,
                "address": "Cebu, Philippines",
                "state": "Cebu",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 11,
                "address": "Central Visayas, Philippines",
                "region": "Central Visayas",
                "country": "Philippines"
            },
            {
                "priority": 12,
                "address": "Philippines",
                "country": "Philippines"
            }
        ]
    }
}`;

const rgeoXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<root>
  <origin>
    <ip>143.44.165.209</ip>
    <type>ipv4</type>
    <platform>macOS</platform>
    <referer/>
    <device>desktop</device>
    <address>
      <city>Cebu City</city>
      <region>07</region>
      <regionName>Central Visayas</regionName>
      <country>PH</country>
      <countryName>Philippines</countryName>
      <postalCode>6000</postalCode>
      <timezone>Asia/Manila</timezone>
    </address>
  </origin>
  <target>
    <lat>10.3451098</lat>
    <lng>123.9223035</lng>
    <address>
      <priority>1</priority>
      <address>8WWC+2WJ, P.Remedio St, Mandaue City, Cebu, Philippines</address>
      <street>P.Remedio Street</street>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>2</priority>
      <address>18b P.Remedio St, Mandaue City, 6014 Cebu, Philippines</address>
      <street_number>18b</street_number>
      <street>P.Remedio Street</street>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
      <postal_code>6014</postal_code>
    </address>
    <address>
      <priority>3</priority>
      <address>6014 P.Remedio St, Mandaue City, Cebu, Philippines</address>
      <street_number>6014</street_number>
      <street>P.Remedio Street</street>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>4</priority>
      <address>18 P.Remedio St, Mandaue City, Cebu, Philippines</address>
      <street_number>18</street_number>
      <street>P.Remedio Street</street>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>5</priority>
      <address>18 P.Remedio St, Mandaue City, Cebu, Philippines</address>
      <street_number>18</street_number>
      <street>P.Remedio Street</street>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>6</priority>
      <address>8WWC+2W Mandaue City, Cebu, Philippines</address>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>7</priority>
      <address>Banilad, Mandaue City, Cebu, Philippines</address>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>8</priority>
      <address>Mandaue City, Cebu, Philippines</address>
      <city>Mandaue City</city>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>9</priority>
      <address>Mandaue City, Cebu, Philippines</address>
      <district>Mandaue City</district>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>10</priority>
      <address>Cebu, Philippines</address>
      <state>Cebu</state>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>11</priority>
      <address>Central Visayas, Philippines</address>
      <region>Central Visayas</region>
      <country>Philippines</country>
    </address>
    <address>
      <priority>12</priority>
      <address>Philippines</address>
      <country>Philippines</country>
    </address>
  </target>
</root>`;

function GTCChannel () {
    const { service, id } = useParams();
    const navigate = useNavigate();
    const [targetIp, setTargetIp] = useState("143.44.165.209");
    const [channelId, setChannelId] = useState(id);
    const [totalRequest, setTotalRequest] = useState(0);
    const [totalLimit, setTotalLimit] = useState(10000);
    const [progress, setProgress] = useState(0);

    const [chanName, setChanName] = useState('');
    const [notifThreshold, setNotifThreshold] = useState('7000');
    const [acl, setAcl] = useState('');
    const [blk, setBlk] = useState('');
    const [live, setLive] = useState(false);
    const [chanKey, setChanKey] = useState('');

    const [chanRecords, setChanRecords] = useState<any[]>([])
    const [lastValEval, setLastValEval] = useState(null);
    const [recordDone, setRecordDone] = useState(false);

    const [statDates, setStatDates] = useState<any[]>([]);
    const [selectStatDate, setSelectStatDate] = useState<string>('');
    const [statData, setStatData] = useState(null);

    // API outputs
    const [originOnly, setOriginOnly] = useState({})
    const [originTarget, setOriginTarget] = useState({});
    const [originTargetXml, setOriginTargetXml] = useState('');
    const fetchRecord = useRef(false);

    const [currentPlan, setCurrentPlan] = useState<any>(null);

    let timeInterval: any = null

    const [time, setTime] = useState('');
    const [date, setDate] = useState('');


    // Scheme
    const [ua, setUa] = useState(false);
    const [plat, setPlat] = useState(false);
    const [ref, setRef] = useState(false);
    const [asn, setAsn] = useState(false);
    const [dev, setDev] = useState(false);
    const [coor, setCoor] = useState(false);
    const [loc, setLoc] = useState(false);
    const [cinfo, setCinfo] = useState(false);
    const [curr, setCurr] = useState(false);
    const [tz, setTz] = useState(false);
    const [lang, setLang] = useState(false);
    const [whois, setWhois] = useState(false);

    const [isHold, setIsHold] = useState(false)

    const [webhook, setWebhook] = useState('');


    // console.log("Channel id", id)

    const updateChannel = async () => {
        let data: any = {
            name: chanName,
            notif: notifThreshold,
            acl: acl,
            blk: blk,
            live: live,
            webhook: webhook || "",
            id: id,
            service: service
        }

        if (service == "geo") {
            data = {
                ...data,
                sch_ua: ua,
                sch_plat: plat,
                sch_ref: ref,
                sch_asn: asn,
                sch_dev: dev,
                sch_coor: coor,
                sch_loc: loc,
                sch_cinfo: cinfo,
                sch_curr: curr,
                sch_tz: tz,
                sch_lang: lang
            }
        }


        try {
            const res = await apiRequest({
                method: "POST",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "updatechan",
                data: data,
                content: "json"
            })
            // console.log("updateChannel", res);
            if (res.status == 200) {
                alert("Success")
                window.location.reload();
            } else {
                alert("Something went wrong. Try again later.");
            }
        } catch (error) {
            console.log("updateChannel", error)
        }
    }

    const getChannel = async () => {
        try {
            const res = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "getchan",
                data: {
                    id: id
                }
            })
            // console.log("getChannel", res);
            if (res.status == 200 && res.data) {
                const data = res.data;

                if (data.service && data.service != service) {
                    navigate("/home");
                    return;
                }

                setChanName(data.name || "");
                setTotalRequest(data.ctr);
                setTotalLimit(data.limit)
                const percent = Number((data.ctr / data.limit) * 100)
                setProgress(Math.round(percent))
                setNotifThreshold(data.notif);
                setAcl(data.acl.join("\n"));
                setBlk(data.blk.join("\n"));
                setChanKey(data.akey)
                setLive(data.live)
                setWebhook(data.webhook || "")

                const plan = data.plan;
                setCurrentPlan(plan);

                setIsHold(data.hold);

                if (service == "geo") {
                    const scheme = data.scheme;
                    setAsn(scheme.asn);
                    setCinfo(scheme.cinfo);
                    setCoor(scheme.coor);
                    setCurr(scheme.curr);
                    setDev(scheme.dev);
                    setLang(scheme.lang);
                    setLoc(scheme.loc);
                    setPlat(scheme.plat);
                    setRef(scheme.ref);
                    setTz(scheme.tz);
                    setUa(scheme.ua);
                    setWhois(scheme.whois);
                }

            } else {
                navigate("/home")
            }
        } catch (error) {
            console.log("getChannel", error)
        }
    }

    const runApi = async () => {
        if (service != "rgeo") {
            await requestOrigin();
            await requestOriginTarget();
            await requestOriginTargetXml();
        }
        await getChanRecords();
        await getStatDates();
    }

    const requestOrigin = async () => {
        const res = await fetch(`https://geo.gotrycatch.com/${id}?key=${chanKey}`);
        const data = await res.json();
        setOriginOnly(data)
    }
    const requestOriginTarget = async () => {
        const res = await fetch(`https://geo.gotrycatch.com/${id}?key=${chanKey}&ip=${targetIp}`);
        const data = await res.json();
        setOriginTarget(data)
    }
    const requestOriginTargetXml = async () => {
        // https://geo.gotrycatch.com/{id}?key={chanKey}&ip=89.0.142.86&output=xml
        const res = await fetch(`https://geo.gotrycatch.com/${id}?key=${chanKey}&ip=${targetIp}&output=xml`);
        const data = await res.text();
        setOriginTargetXml(data)
    }

    const resetChanKey = async () => {
        if (!window.confirm("Do you want to reset the channel key?")) {
            return;
        }
        try {
            const data = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "resetchankey",
                data: {
                    id: id
                }
            })
            if (data && data.status == 200) {
                window.location.reload();
            } else {
                alert("Something went wrong. Please try again later.")
            }
        } catch (error) {
            console.log("resetChanKey", error)
        }
    }

    const getChanRecords = async () => {

        if (fetchRecord.current || recordDone) {
            return;
        }
        fetchRecord.current = true;
        
        try {
            const data = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "getchanrecords",
                data: {
                    id: id,
                    lastValEval: lastValEval ? JSON.stringify(lastValEval) : '',
                    service: service
                }
            })
            // console.log("chanRecords", data)
            if (data && data.status == 200) {
    
                if (recordDone) {
                    return;
                }
    
                const items = data.items;
                setChanRecords([ ...chanRecords, ...items]);
                setLastValEval(data.lastValEval);  
    
                if (items.length >= 0 && !data.lastValEval) {
                    setRecordDone(true);
                }
            }
        } catch (error) {
            console.log("getChanRecords", error)
        }
        fetchRecord.current = false;
    }

    const getStat = async (statDate: string) => {
        try {
            const data = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "getstat",
                data: {
                    id: id,
                    key: statDate,
                    service: service
                }
            })
            // console.log("getStat", data);
            if (data && data.status == 200) {
                setStatData(data?.data?.data);
            }
        } catch (error) {
            console.log("getStat", error)
        }
    }

    // getstatdates
    const getStatDates = async () => {
        try {
            const data = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "getstatdates",
                data: {
                    id: id,
                    service: service
                }
            })
            // console.log("getStatDates", data);
            if (data && data.status == 200) {
                setStatDates(data.data);
                if (data && data?.data && data.data.length > 0) {
                    setSelectStatDate(data.data[0].key);
                    getStat(data.data[0].key);
                }
            }
        } catch (error) {
            console.log("getStatDates", error);
        }
    }

    const deleteChannel = async () => {
        if (window.confirm("Do you want to delete the channel?")) {
            try {
                const data = await apiRequest({
                    method: "GET",
                    api: API_CONSTANTS.PRIVATE_API,
                    fn: "deletechannel",
                    data: {
                        chanId: id,
                        service: service
                    }
                })
                if (data && data.status == 200) {
                    alert("Success");
                    window.location.reload()
                }
                else {
                    alert(data.message)
                }
            } catch (error) {
                console.log("deleteChannel", error);
            }
        }
    }


    useEffect(() => {
        getChannel();
        setChannelId(id);

        if (timeInterval) {
            clearInterval(timeInterval)
        }
        timeInterval = setInterval(function () {
            setTime(moment().utc().format("h:mm:ss a"));
            setDate(moment().utc().format("MMM Do YY"));
        }, 1000)
    }, [])

    useEffect(() => {
        if (chanKey) {
            runApi();
        }
    }, [chanKey])


    let serviceName = "Unknown";
    if (service == "geo") {
        serviceName = "IP Geolocation";
    } else {
        serviceName = "Reverse Geocoding";
    }


    return (
        <div className="channel-page">
            <div className='channel-dashboard'>
                <div className="page-header">
                    <div className="header-title-section">
                        <h1>{chanName || "Channel"}</h1>
                        <div className="service-type">
                            <span className="service-name">{serviceName}</span>
                        </div>
                        <p>Manage your channel settings and monitor performance</p>
                    </div>
                </div>

                

                <div className="channel-content">

                    {/* Add Payment Alert Component */}
                    {
                        isHold ? (
                            <div className="channel-payment-alert">
                                <div className="channel-alert-content">
                                    <FaExclamationTriangle className="channel-alert-icon" />
                                    <div className="channel-alert-text">
                                        <h3 className="channel-alert-title">Your Channel Is On Hold</h3>
                                        <p className="channel-alert-message">
                                        Your channel is currently on hold due to a payment issue. To resolve this easily, simply cancel your subscription and then resubscribe to your desired plan.
                                        </p>
                                    </div>
                                    <button 
                                        className="channel-alert-action"
                                        onClick={() => navigate("/subscriptions")}
                                    >
                                        Update Payment
                                    </button>
                                </div>
                            </div>
                        ) : null
                    }

                    <GTCDisplayPlan plan={currentPlan?.plan || "free"}/>
                    
                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">Channel Overview</h2>
                        </div>
                        <div className="card-content">
                            <div className="stats-grid">
                                <div className="stat-box">
                                    <div className="stat-label">Requests</div>
                                    <div className="stat-value">{totalRequest}</div>
                                </div>
                                <div className="stat-box">
                                    <div className="stat-label">Limit</div>
                                    <div className="stat-value">{totalLimit}</div>
                                </div>
                                <div className="stat-box">
                                    <div className="stat-label">Time (UTC)</div>
                                    <div className="stat-value">{time}</div>
                                    <div className="stat-subtext">{date}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">Usage Statistics</h2>
                        </div>
                        <div className="card-content">
                            <div className="progress-section">
                                <GTCLinearProgress progress={progress} />
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">Analytics</h2>
                            <select 
                                className="custom-input"
                                style={{ width: 'auto' }}
                                onChange={(e) => {
                                    setSelectStatDate(String(e.target.value));
                                    getStat(String(e.target.value))
                                }}
                            >
                                {statDates.map((date, i) => {
                                    const keyDate = moment(date.key, "MMDDYYYY").format("MM-DD-YYYY");
                                    return (
                                        <option key={i} value={date.key}>{keyDate} UTC</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="card-content">
                            <GTCChart data={statData}/>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">Channel Settings</h2>
                        </div>
                        <div className="card-content">
                            <div className="settings-form">
                                <div className="form-group">
                                    <label className="form-label">Channel Name</label>
                                    <input 
                                        className="custom-input"
                                        onChange={(e) => setChanName(e.target.value)}
                                        value={chanName}
                                    />
                                </div>

                                {
                                    service == "geo" ? (
                                        <>
                                            <div className="form-group">
                                                <label className="form-label">Expected Data</label>
                                                <div className="switch-group">
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={ua} onChange={(e) => setUa(e.target.checked)}/>} label="User Agent" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={plat} onChange={(e) => setPlat(e.target.checked)}/>} label="Platform" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={ref} onChange={(e) => setRef(e.target.checked)}/>} label="Referer" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={asn} onChange={(e) => setAsn(e.target.checked)}/>} label="ASN" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={dev} onChange={(e) => setDev(e.target.checked)}/>} label="Device" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={coor} onChange={(e) => setCoor(e.target.checked)}/>} label="Coordinates" />
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label className="form-label">Location</label>
                                                <div className="switch-group">
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={loc} onChange={(e) => setLoc(e.target.checked)}/>} label="Location" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={cinfo} onChange={(e) => {
                                                            if (!e.target.checked) {
                                                                setCurr(false);
                                                                setTz(false);
                                                                setLang(false);
                                                            }
                                                            setCinfo(e.target.checked)
                                                        }}/>} label="Country Information" />
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label className="form-label">Currency</label>
                                                <div className="switch-group">
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={curr} onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setCinfo(e.target.checked)
                                                            }
                                                            setCurr(e.target.checked)
                                                        }}/>} label="Currency" />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={tz} onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setCinfo(e.target.checked)
                                                            }
                                                            setTz(e.target.checked)
                                                        }}/>} label="Timezones" />
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label className="form-label">Languages</label>
                                                <div className="switch-group">
                                                    <FormGroup>
                                                        <FormControlLabel control={<Switch checked={lang} onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setCinfo(e.target.checked)
                                                            }
                                                            setLang(e.target.checked)
                                                        }}/>} label="Languages" />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </>
                                    ) : null
                                }

                                <div className="form-group">
                                    <label className="form-label">Threshold Notification</label>
                                    <input 
                                        type="number"
                                        className="custom-input"
                                        onChange={(e) => setNotifThreshold(e.target.value)}
                                        value={notifThreshold}
                                    />
                                    <p className="form-note">You will receive an email notification when this threshold is reached.</p>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Grant Access</label>
                                    <textarea 
                                        className="custom-input custom-textarea"
                                        rows={8}
                                        value={acl}
                                        onChange={(e) => setAcl(e.target.value)}
                                        placeholder={placeholder}
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Deny Access</label>
                                    <textarea 
                                        className="custom-input custom-textarea"
                                        rows={8}
                                        value={blk}
                                        onChange={(e) => setBlk(e.target.value)}
                                        placeholder={placeholder}
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Channel Status</label>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch checked={live} onChange={(e) => setLive(e.target.checked)}/>} label="Live" />
                                    </FormGroup>
                                    <p className="form-note">Enable to allow the channel to accept requests.</p>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Webhook URL</label>
                                    <input 
                                        className="custom-input"
                                        value={webhook}
                                        onChange={(e) => setWebhook(e.target.value)}
                                        placeholder="https://yourdomain.com/pathname"
                                    />
                                    <p className="form-note">We recommend setting up the endpoint using the POST method.</p>
                                </div>

                                <button className="action-button" onClick={updateChannel}>
                                    Update Channel
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">API Configuration</h2>
                            <button className="action-button" onClick={resetChanKey}>Reset Key</button>
                        </div>
                        <div className="card-content">
                            <div className="form-group">
                                <label className="form-label">API Key</label>
                                <div className="api-section">
                                    <code className="api-key">{chanKey}</code>
                                </div>
                            </div>

                            {
                                service == "rgeo" ? (
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Endpoint</label>
                                            <div className="api-section">
                                                <code className="api-key">https://rgeo.gotrycatch.com/{id}?key={chanKey}&latlng=10.3451098,123.9223035</code>
                                            </div>
                                            <label className="form-label">Response</label>
                                            <div className="api-section">
                                                <ReactJson 
                                                    style={{ maxHeight: "500px", overflowY: "scroll" }}
                                                    src={JSON.parse(rgeoJson)} theme="monokai"/>
                                            </div>
                                        </div>
                                    </>
                                ) : null
                            }
                            {
                                service == "rgeo" ? (
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Endpoint</label>
                                            <div className="api-section">
                                                <code className="api-key">https://rgeo.gotrycatch.com/{id}?key={chanKey}&lat=10.3451098&lng=123.9223035</code>
                                            </div>
                                            <div className="api-section">
                                                <ReactJson 
                                                    style={{ maxHeight: "500px", overflowY: "scroll" }}
                                                    src={JSON.parse(rgeoJson)} theme="monokai"/>
                                            </div>
                                        </div>
                                    </>
                                ) : null
                            }

                            {
                                service == "geo" ? (
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Base Endpoint</label>
                                            <div className="api-section">
                                                <code className="api-key">https://geo.gotrycatch.com/{id}?key={chanKey}</code>
                                            </div>
                                            <div className="api-section">
                                                <ReactJson 
                                                    style={{ maxHeight: "500px", overflowY: "scroll" }}
                                                    src={originOnly} theme="monokai"/>
                                            </div>
                                        </div>
                                    </>
                                ) : null
                            }

                            {
                                service == "geo" ? (
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Endpoint with target IP address:</label>
                                            <div className="api-key-container" >
                                                <div className="api-section" style={{width: "100%"}}>
                                                    <code className="api-key"><b>https://geo.gotrycatch.com/{id}?key={chanKey}&ip={targetIp}</b></code>
                                                </div>
                                            </div>
                                            <label className="class-field-header">Response Data:</label>
                                            <div>
                                                <ReactJson 
                                                    style={{ maxHeight: "500px", overflowY: "scroll" }}
                                                    src={originTarget} theme="monokai"/>
                                            </div>
                                        </div>
                                    </>
                                ) : null
                            }

                            {
                                service == "geo" ? (
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Endpoint with output format:</label>
                                            <div className="api-key-container" >
                                                <div className="api-section" style={{width: "100%"}}>
                                                    <code className="api-key"><b>https://geo.gotrycatch.com/{id}?key={chanKey}&ip={targetIp}&output=xml</b></code>
                                                </div>
                                            </div>
                                            <label className="class-field-header">Response XML format:</label>
                                            <div>
                                                <AceEditor
                                                    placeholder="Placeholder Text"
                                                    mode="xml"
                                                    theme="monokai"
                                                    name="xml"
                                                    readOnly={true}
                                                    fontSize={14}
                                                    lineHeight={19}
                                                    showPrintMargin={true}
                                                    showGutter={true}
                                                    highlightActiveLine={true}
                                                    style={{ width: "100%" }}
                                                    value={originTargetXml}
                                                    setOptions={{
                                                        enableBasicAutocompletion: false,
                                                        enableLiveAutocompletion: false,
                                                        enableSnippets: false,
                                                        enableMobileMenu: true,
                                                        showLineNumbers: true,
                                                        tabSize: 2,
                                                        useWorker: false
                                                    }}/>
                                            </div>
                                        </div>
                                    </>
                                ) : null
                            }
                            {
                                service == "rgeo" ? (
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Endpoint with output format:</label>
                                            <div className="api-key-container" >
                                                <div className="api-section" style={{width: "100%"}}>
                                                    <code className="api-key"><b>https://rgeo.gotrycatch.com/{id}?key={chanKey}&lat=10.3451098&lng=123.9223035&output=xml</b></code>
                                                </div>
                                            </div>
                                            <label className="class-field-header">Response XML format:</label>
                                            <div>
                                                <AceEditor
                                                    placeholder="Placeholder Text"
                                                    mode="xml"
                                                    theme="monokai"
                                                    name="xml"
                                                    readOnly={true}
                                                    fontSize={14}
                                                    lineHeight={19}
                                                    showPrintMargin={true}
                                                    showGutter={true}
                                                    highlightActiveLine={true}
                                                    style={{ width: "100%" }}
                                                    value={rgeoXml}
                                                    setOptions={{
                                                        enableBasicAutocompletion: false,
                                                        enableLiveAutocompletion: false,
                                                        enableSnippets: false,
                                                        enableMobileMenu: true,
                                                        showLineNumbers: true,
                                                        tabSize: 2,
                                                        useWorker: false
                                                    }}/>
                                            </div>
                                        </div>
                                    </>
                                ) : null
                            }


                            <div className="form-group mt-4">
                                <label className="form-label">Example:</label>
                                <div className="mb-2">
                                    <AceEditor
                                        placeholder="Placeholder Text"
                                        mode="javascript"
                                        theme="monokai"
                                        name="js"
                                        readOnly={true}
                                        fontSize={14}
                                        lineHeight={19}
                                        showPrintMargin={true}
                                        showGutter={true}
                                        highlightActiveLine={true}
                                        style={{ width: "100%" }}
                                        value={
                                            service == "geo" ?
                                            jsGeoFetch(`https://geo.gotrycatch.com/${id}`, chanKey, targetIp) 
                                            : jsRgeoFetch(`https://rgeo.gotrycatch.com/${id}`, chanKey, "10.3451098", "123.9223035")
                                        }
                                        setOptions={{
                                            enableBasicAutocompletion: false,
                                            enableLiveAutocompletion: false,
                                            enableSnippets: false,
                                            enableMobileMenu: true,
                                            showLineNumbers: true,
                                            tabSize: 2,
                                            useWorker: false
                                        }}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">API Data Report</h2>
                            <p className="form-note">Data reports will be automatically deleted after 30 days.</p>
                        </div>
                        <div className="card-content">
                            <GTCReportTable items={chanRecords} />
                            <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                                <button className="action-button" onClick={getChanRecords}>
                                    Load More Data
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        <div className="card-header">
                            <h2 className="card-title">Grant and Deny Guide</h2>
                        </div>
                        <div className="card-content">
                            <GTCUsageGuide />
                        </div>
                    </div>


                    <div className="dashboard-card">
                        <div className="card-content" style={{ textAlign: 'center' }}>
                            <button className="action-button danger-button" onClick={deleteChannel}>
                                Delete Channel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GTCChannel;